import {MarketListItem, ProductType, PropertyField} from "@/models/frontend/MarketModels";
import {Listing, ListingStatus} from "@/models/backend/ListingModels";
import Session from "supertokens-web-js/recipe/session";


export function transformListingStatus(status : ListingStatus) : string {
    switch (status) {
        case ListingStatus.DRAFT:
            return "Borrador";
        case ListingStatus.PUBLISHED:
            return "Activo";
        case ListingStatus.CLOSED:
            return "Cerrado";
        case ListingStatus.SOLD:
            return "Vendido";
        default:
            return "Desconocido";
    }
}


export async function transformToFrontendListing(listing: any): Promise<Listing> {

    const doesSessionExist = await Session.doesSessionExist();
    let userId = "";
    if(doesSessionExist) {
        userId = await Session.getUserId();
    }

    return {
        id: listing.id,
        templateId: listing.templateId || '',
        type: listing.type,
        userId: listing.userId,
        isOwner: userId === listing.userId,
        quantity: Number(listing.quantity),
        price: Number(listing.price),
        shippingPrices: listing.shippingPrices || [],
        shippingAvailable: listing.shippingAvailable,
        pickupAvailable: listing.pickupAvailable,
        availableDate: listing.availableDate,
        endDate: listing.endDate,
        postalCode: listing.postalCode,
        workingDays: listing.workingDays,
        workingHours: listing.workingHours || '',
        featureValues: listing.listingFeatureValues.map((feature: any) => ({
            id: feature.id,
            featureId: feature.featureId,
            featureName: feature.featureName,
            name: feature.featureLabel,
            featureLabel: feature.featureLabel,
            featureValues: feature.featureValues.map((value: any) => value.value)
        })),
        status: listing.status,
        createdAt: listing.createdAt || '',
        updatedAt: listing.updatedAt || '',
        country: {
            isoCode: listing.country.isoCode,
            name: listing.country.name || ''
        },
        distance: listing.distance || 0,
        images: listing.images || [],
        customerCertifications: listing.certifications || []
    };
}


export function transformListingToMarketListItem(listing: any): MarketListItem {
    const properties: PropertyField[] = [
        {
            order: 1,
            label: "Ubicación",
            value: listing.city + ", " + listing.postalCode,
            size: 1,
            styleMobile: "Default",
        },
        {
            order: 2,
            label: "Distancia",
            value: listing.distanceInKm ? `~ ${listing.distanceInKm} Km` : "0 Km",
            size: 1,
            styleMobile: "Default",
        },
        {
            order: 3,
            label: "Cantidad",
            value: `${listing.quantity} uds`,
            highlighted: true,
            size: 1,
            styleMobile: "Default",
        },
        {
            order: 4,
            label: "Precio/ud",
            value: isNaN(Number(listing.price))
                ? "N/A"
                : Number(listing.price).toFixed(2) + " €/ud",
            highlighted: true,
            size: 1,
            styleMobile: "Default",
        },
        {
            order: 5,
            label: "Material",
            value: listing.listingFeatureValues
                ?.find((fv: any) => fv.featureName === "material")
                ?.featureValues.map((fv: any) => fv.value)
                .join(", ") || "N/A",
            size: 1,
            styleMobile: "Default",
        },
        {
            order: 6,
            label: "Estado",
            value: listing.listingFeatureValues
                ?.find((fv: any) => fv.featureName === "status")
                ?.featureValues.map((fv: any) => fv.value)
                .join(", ") || "N/A",
            highlighted: false,
            size: 1,
            styleMobile: "Default",
        },
        {
            order: 7,
            label: "Certificados",
            value: listing.listingFeatureValues
                ?.find((fv: any) => fv.featureName === "certificates")
                ?.featureValues.map((fv: any) => fv.value)
                .join(", ") || "N/A",
            highlighted: false,
            size: 1,
            styleMobile: "Default",
        },
        {
            order: 8,
            label: "Tipo entrega",
            value: `${listing.shippingAvailable && listing.pickupAvailable ? "Envío / Recogida" : listing.pickupAvailable && !listing.shippingAvailable ? "Recogida": "Envío"}`,
            size: 1,
            styleMobile: "Default",
        },  
    ];

    return {
        id: listing.id,
        type: listing.type === "SALE" ? "seller" : "buyer",
        city: listing.city,
        product: listing.listingFeatureValues
            ?.find((fv: any) => fv.featureName === "material")
            ?.featureValues[0]?.value || "Unknown",
        userId: listing.userId,
        rating: listing.customerRating || 5,
        images: listing.images,
        properties,
        active: false,
        location: listing.postalCode || "",
        featureValues: listing.listingFeatureValues.map((fv: any) => ({
            ...fv,
            featureValues: fv.featureValues.map((fv: any) => fv.value)
        })),
        userName: listing.customerName,
        certifications: listing.certifications
    };
}